import React, { useState, useEffect } from "react";
import styles from "../assets/css/UserList.module.css";
import { NavLink } from "react-router-dom";
import { Loader } from "../../components/Loader";
import { postData1 } from "../../services";
import { Pagination } from "../Common";
import { nullToEmptyString } from "../../utils/purefun";

// conflict resolved
export const ArrangeDemoList = () => {
  const [requestlistData, setRequestListData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currPage, setCurrPage] = useState(1);
  const [paging, setPaging] = useState({});
  const [prevPage, setPrevPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'asc',
  });

  const updatePage = (e) => {
    let name = e.currentTarget.name;
    if (name === "prev") {
      setCurrPage(currPage === 1 ? 1 : currPage - 1);
      setPrevPage(currPage);
    } else if (name === "next") {
      setCurrPage(currPage === paging?.total_pages ? currPage : currPage + 1);
      setPrevPage(currPage);
    } else {
      setCurrPage(parseInt(e.currentTarget.innerHTML));
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedData = React.useMemo(() => {
    let sortedArray = [...requestlistData];
    if (sortConfig.key) {
      sortedArray.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortedArray;
  }, [requestlistData, sortConfig]);

  useEffect(() => {
    (async () => {
      const config = { _page: currPage, _limit: 8 };
      const res = await postData1(
        "admin/arrange_demo_list/",
        config,
        true,
        true
      );
      setRequestListData(res?.data?.data);
      setPaging({
        total: res?.data?.total,
        total_pages: res?.data?.total_pages,
      });
      setLoader(false);
    })();
  }, [currPage]);

  return (
    <section className={styles.userListCont}>
      <div className={styles.listHead}>
        <h1>DEMO REQUEST MANAGEMENT</h1>
      </div>
      <div className={styles.dataItems}>
        <div className={styles.itemHead}>
          <span onClick={() => requestSort('id')}>
            REQUEST ID
            {sortConfig.key === 'id' ? (
              sortConfig.direction === 'asc' ? ' ↑' : ' ↓'
            ) : null}
          </span>
          <span onClick={() => requestSort('created_date')}>
            DATE
            {sortConfig.key === 'created_date' ? (
              sortConfig.direction === 'asc' ? ' ↑' : ' ↓'
            ) : null}
          </span>
          <span onClick={() => requestSort('equip_name')}>
            EQUIPMENT
            {sortConfig.key === 'equip_name' ? (
              sortConfig.direction === 'asc' ? ' ↑' : ' ↓'
            ) : null}
          </span>
          <span onClick={() => requestSort('buyer_firstname')}>
            BUYER
            {sortConfig.key === 'buyer_firstname' ? (
              sortConfig.direction === 'asc' ? ' ↑' : ' ↓'
            ) : null}
          </span>
          <span onClick={() => requestSort('seller_firstname')}>
            SELLER
            {sortConfig.key === 'seller_firstname' ? (
              sortConfig.direction === 'asc' ? ' ↑' : ' ↓'
            ) : null}
          </span>
          <span>DETAIL</span>
        </div>

        {sortedData?.map((data, index) => {
          return (
            <div className={styles.itemData} key={index}>
              <span>{data?.id}</span>
              <span>{new Date(data?.created_date).toDateString()}</span>
              <span>{data?.equip_name}</span>
              <span>{`${nullToEmptyString(
                data?.buyer_firstname
              )} ${nullToEmptyString(data?.buyer_lastname)}`}</span>
              <span>{`${nullToEmptyString(
                data?.seller_firstname
              )} ${nullToEmptyString(data?.seller_lastname)}`}</span>
              <span>
                <NavLink to="demoview/" state={{ item: data }}>
                  View
                </NavLink>
              </span>
            </div>
          );
        })}
      </div>
      <Pagination
        total={paging?.total}
        perPage={8}
        currPage={currPage}
        prevPage={prevPage}
        tPage={paging?.total_pages}
        updatePage={updatePage}
      />

      {loader && <Loader />}
    </section>
  );
};
